// extracted by mini-css-extract-plugin
var _1 = "assets-js-ViewInvitation-components-Guestlist-GuestSummary-module__actions__bibrT";
var _2 = "assets-js-ViewInvitation-components-Guestlist-GuestSummary-module__actionsBlock__hc60U";
var _3 = "assets-js-ViewInvitation-components-Guestlist-GuestSummary-module__container__CqvpF";
var _4 = "assets-js-ViewInvitation-components-Guestlist-GuestSummary-module__headcount__hI5Br";
var _5 = "assets-js-ViewInvitation-components-Guestlist-GuestSummary-module__infoBlock__IeP7Y";
var _6 = "assets-js-ViewInvitation-components-Guestlist-GuestSummary-module__nameBlock__tgn9Y";
export { _1 as "actions", _2 as "actionsBlock", _3 as "container", _4 as "headcount", _5 as "infoBlock", _6 as "nameBlock" }
